import { render, staticRenderFns } from "./ApiCrm.vue?vue&type=template&id=35d00340"
import script from "./ApiCrm.vue?vue&type=script&lang=js"
export * from "./ApiCrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports